import { COLOR } from 'vars/index'

export const NavTabBackground = {
  COLOR_TRANSPARENT: COLOR.TRANSPARENT,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  SURFACE_OPACITY_LIGHT_15: COLOR.SURFACE_OPACITY_LIGHT_15,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
} as const
export type NavTabBackground =
  (typeof NavTabBackground)[keyof typeof NavTabBackground]

export const NavTabIconSize = {
  Small: 'small',
  Medium: 'medium',
} as const
export type NavTabIconSize =
  (typeof NavTabIconSize)[keyof typeof NavTabIconSize]

export const NavDirection = {
  COLUMN: 'column',
  ROW: 'row',
} as const
export type NavDirection = (typeof NavDirection)[keyof typeof NavDirection]

export const NavTabJustifyContent = {
  Start: 'flex-start',
  End: 'flex-end',
  Center: 'center',
} as const
export type NavTabJustifyContent =
  (typeof NavTabJustifyContent)[keyof typeof NavTabJustifyContent]
